import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FiArrowLeft } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import { cpf } from 'cpf-cnpj-validator';
import { validate } from 'email-validator';

import logo from '../../assests/logo-transparent.png';
import fotoAgro from '../../assests/register-hero.png';
import api from '../../services/api';

import './styles.css';

// gakasen577@1adir.com
// agro123456

// xinoh97422@dashseat.com
// agro123456

// hovedi8477@aiclbd.com
// agro123456

export default function Register() {
  const { t } =  useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [CPF, setCPF] = useState('');
  const [password, setPassword] = useState('');
  const [password_confirmation, setPassword_confirmation] = useState('');
  const [termo, setTermo] = useState(0);
  const [avatar, setAvatar] = useState('');
  const [nickname, setNickname] = useState('');
  const [plataform, setPlataform] = useState('android');
  const [indicador_id, setIndicador_id] = useState('');
  const [interested_tags, setInterested_tags] = useState([]);
  const [allow_advertising, setAllowAdvertising] = useState(false);
  const history = useHistory();
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const [erros, setErros] = useState([]);
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const [ind, setInd] = useState([]);

  useEffect(() => {
    api.get("/v4/indicators", {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
        'PARAMS': '',
        'Content-Type': 'application/json'
      }
    }).then(response => {
      setInd(response.data);
    });
  }, [USER_EMAIL, USER_TOKEN, history])

  async function geraNick(e) {
    if (e) {
      await api.get(`/v4/users/suggestion_for_nickname?name=${e}`, {
      }).then(response => {
        setNickname(response.data.nickname)
      });

      //setNickname(response.data.nickname);

      // let nc = e.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      // nc = nc.toLowerCase();
      // nc = nc.replace(' ', '_');
      // nc = nc.replace(' ', '_');
      // nc = nc.replace(' ', '_');
      // nc = nc.replace(' ', '_');
      // nc = nc.replace(' ', '_');
      // setNickname(nc);
    }
  }
  function mostrarSuccess() {
    let msg = document.getElementById('success');
    if (msg) msg.style.display = 'block';
    let btn = document.getElementById('btn-enviar');
    if (btn) btn.disabled = true;

    setTimeout(() => {
      const atual = document.getElementById('success');
      if (atual) atual.style.display = 'none';
      history.push("/");
    }, 5000)
  }

  function mostrarErros() {
    let msg = document.getElementById('msg');
    if (!msg) return;
    msg.style.display = 'block';
    setTimeout(() => {
      const atual = document.getElementById('msg');
      if (atual) atual.style.display = 'none';
    }, 5000)
  }

  function log(e) {
  }

  function limpaTelefone(phone) {
    var v = phone.replace("(", "");
    v = v.replace(")", "");
    v = v.replace(" ", "");
    setPhone(v);
  }

  function limpaCPF(cpf) {
    var v = cpf.replace("-", "");
    v = v.replace(".", "");
    v = v.replace(".", "");
    v = v.replace(" ", "");
    setCPF(v);
  }

  function validacaoEmail(field) {
    var usuario = field.substring(0, field.indexOf("@"));
    var dominio = field.substring(field.indexOf("@") + 1, field.length);

    if ((usuario.length >= 1) &&
      (dominio.length >= 3) &&
      (usuario.search("@") == -1) &&
      (dominio.search("@") == -1) &&
      (usuario.search(" ") == -1) &&
      (dominio.search(" ") == -1) &&
      (dominio.search(".") != -1) &&
      (dominio.indexOf(".") >= 1) &&
      (dominio.lastIndexOf(".") < dominio.length - 1)) {
      return true;
    } else {
      return false;
    }
  }

  function handleRegister(e) {
    log(e);
    limpaCPF(CPF);
    limpaTelefone(phone);
    e.preventDefault();
    sessionStorage.setItem('cpf', CPF);
    const data = {
      email,
      phone,
      name,
      avatar: '',
      nickname,
      CPF,
      indicador_id,
      allow_advertising,
      password,
      password_confirmation,
      interested_tags: [],
    };
    var divErro = document.getElementById('msg');
    var termo = document.getElementById('termo');
    divErro.innerHTML = `<p><strong>${t('pages.register.errors.invalid')}</strong></p>`
    if (name === '') {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.fullname')}</p>`;
      return false;
    }
    if (nickname === '') {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.nickname')}</p>`;
      return false;
    }
    if (email === '') {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.email')}</p>`;
      return false;
    }
    if (validacaoEmail(email)) {
    } else {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.invalidEmail')}</p>`;
      return false;
    }
    limpaTelefone(phone);
    if (phone === '') {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.cellphone')}</p>`;
      return false;
    }

    if (phone.length === 11 || phone.length === 14) {
    } else {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.invalidCellphone')}</p>`;
      return false;
    }
    if (CPF === '') {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.cpf')}</p>`;
      return false;
    }
    if (cpf.isValid(CPF) === false) {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.invalidCpf')}</p>`;
      return false;
    }
    if (password === '') {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.password')}</p>`;
      return false;
    }
    if (password !== password_confirmation) {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.matchPassword')}</p>`;
      return false;
    }
    if (!termo.checked) {
      mostrarErros();
      divErro.innerHTML += `<p>${t('pages.register.errors.terms')}</p>`;
      return false;
    }

    var axios = require('axios');
    //var data = JSON.stringify({"email":"vic2tor2costa@gmail.com","phone":"67992553097","name":"Victor Costa","avatar":"","nickname":"victorcost2a1234","cpf":"04601338107","indicator_id":"","password":"secret123","password_confirmation":"secret123","interested_tags":[1,2,3,4]});

    var config = {
      method: 'post',
      url: BASE_URL + '/v5/users',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        mostrarSuccess();

      }).catch(function (error) {
        setErros(error.response.data.errors);
        mostrarErros();
      });
  }

  function mascaraTel(e) {
    if (e.length > 2) {
      e = e.replace(/\D/g, "");
      e = e.replace(/^(\d{2})(\d)/g, "($1) $2");
    }
    setPhone(e);
  }

  function mascaraCPF(e) {
    e = e.replace(/\D/g, "")
    e = e.replace(/(\d{3})(\d)/, "$1.$2")
    e = e.replace(/(\d{3})(\d)/, "$1.$2")
    e = e.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    setCPF(e);
  }

  function cheked(e) {
    const chk = document.getElementById('checkInd');
    const slConheceu = document.getElementById('slConheceu');
    if (chk.checked) {
      slConheceu.style.display = 'block';
    } else {
      slConheceu.style.display = 'none';
      setIndicador_id(0);
    }
  }

  function termos() {
    window.location.href = 'https://agrobrazilapp.com/terms-of-use'; 
  }

  return (
    <div className="cadastro-page">
      <section className="register-form-col">
        <div className="register-card">
          <img className="logo" src={logo} alt={t('commons.alt.agroPicture')} />
          <h1>{t('pages.register.header')}</h1>
          <p className="register-sub">{t('pages.register.subheader')}</p>
          <form onSubmit={handleRegister}>
            <div className="register-fields">
            <label>
              {t('pages.register.placeholder.fullname')}
              <input
                type="text"
                placeholder={t('pages.register.placeholder.fullname')}
                value={name}
                onChange={e => setName(e.target.value)}
                onBlur={e => geraNick(e.target.value)}
              />
            </label>
            <label>
              {t('pages.register.placeholder.nickname')}
              <input
                type="text"
                placeholder={t('pages.register.placeholder.nickname')}
                value={nickname}
                onChange={e => setNickname(e.target.value)}
                readOnly="true"
              />
            </label>
            <label>
              {t('pages.register.placeholder.email')}
              <input
                type="email"
                placeholder={t('pages.register.placeholder.email')}
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </label>
            <label>
              {t('pages.register.placeholder.cellphone')}
              <input
                type="tel"
                placeholder={t('pages.register.placeholder.cellphone')}
                value={phone}
                onChange={e => setPhone(e.target.value)}
                maxlength="14"
                onKeyUp={e => mascaraTel(e.target.value)}
              />
            </label>
            <label>
              {t('pages.register.placeholder.cpf')}
              <input
                placeholder={t('pages.register.placeholder.cpf')}
                maxlength="14"
                value={CPF}
                onChange={e => setCPF(e.target.value)}
                onKeyUp={e => mascaraCPF(e.target.value)}
              />
            </label>
            <label>
              {t('pages.register.placeholder.password')}
              <input
                type="password"
                placeholder={t('pages.register.placeholder.password')}
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </label>
            <label>
              {t('pages.register.placeholder.passwordConfirm')}
              <input
                type="password"
                placeholder={t('pages.register.placeholder.passwordConfirm')}
                value={password_confirmation}
                onChange={e => setPassword_confirmation(e.target.value)}
                onBlur={e => log(e.target.value)}
              />
            </label>
            </div>
            <div className="register-checks">
            <div className="register-check">
              <input className="checkInd" id="checkInd" type="checkbox" onClick={(e) => cheked(e)} />
              <label htmlFor="checkInd">{t('pages.register.inputs.meet')}</label>
            </div>
            <select id="slConheceu" className="slConheceu" style={{ 'display': 'none' }} value={indicador_id}
              onChange={e => setIndicador_id(e.target.value)}>
              <option>{t('pages.register.inputs.indication')}</option>
              {
                ind.map(indicador => (
                  <option key={indicador.id} value={indicador.id}>{indicador.name}</option>
                ))}
            </select>
            <div className="register-check">
              <input className="checkInd" id="checkboxAllowAdvertising" type="checkbox" onClick={(e) => setAllowAdvertising(!allow_advertising)} />
              <label htmlFor="checkboxAllowAdvertising">{t('pages.register.inputs.acceptedNews')}</label>
            </div>
            <div className="register-check">
              <input
                className="check"
                id="termo"
                type="checkbox"
                onChange={e => setTermo(e.target.value)}
              />
              <label htmlFor="termo">
                <Trans components={{ span: <span className="lkTermo" onClick={termos} >, spanEnd: </span> }}> {t('pages.register.inputs.terms')} </Trans>
              </label>
            </div>
            </div>
            <div className="register-actions">
              <button className="register-enter" type="submit" id="btn-enviar">{t('pages.register.buttons.confirm')}</button>
              <Link className="register-back" to="/">
                <FiArrowLeft size={16} /> {t('pages.register.toLogin')}
              </Link>
            </div>
            <div className="success" id="success">
              <p><strong>{t('pages.register.success')}</strong></p>
            </div>
            <div className="alert" id="msg">
              <p><strong>{t('pages.register.error')}</strong></p>
              {erros.map(err => (
                <p key={err}>- {err}</p>
              ))}
            </div>
          </form>
        </div>
      </section>
      <div className="register-hero">
        <img src={fotoAgro} alt={t('commons.alt.agroPicture')} />
      </div>
    </div>
  );
}
